<stx-radio-group [controlName]="controlName" [formGroup]="formGroupReference" [options]="statsTypes" layoutDirection="column">
</stx-radio-group>
